import React, { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { getAPIBaseURL } from '../services/helpers'
import { getData } from '../services/request'
import Maintenance from './Maintenance'

const POLL_INTERVAL_MS = 60 * 1000

const isAdminPath = (pathname) =>
  pathname === '/admin' || pathname.startsWith('/admin/')

const MaintenanceGate = () => {
  const location = useLocation()
  const [status, setStatus] = useState({ enabled: false, message: '' })

  useEffect(() => {
    let cancelled = false

    const fetchStatus = async () => {
      const res = await getData(`${getAPIBaseURL()}/employme/public/maintenance`, {}, {})
      if (cancelled) return
      if (res.error === '' && res.result?.status === 200) {
        const data = res.result.data?.data || res.result.data
        setStatus({
          enabled: data?.enabled === true,
          message: data?.message || ''
        })
      }
    }

    fetchStatus()
    const interval = setInterval(fetchStatus, POLL_INTERVAL_MS)
    return () => {
      cancelled = true
      clearInterval(interval)
    }
  }, [])

  if (status.enabled && !isAdminPath(location.pathname)) {
    return <Maintenance message={status.message} />
  }

  return <Outlet />
}

export default MaintenanceGate
